// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gm-style-iw-chr {
    display: none;
}

/* Prevent text selection on Google Maps elements */
.gm-style,
.gm-style * {
    -webkit-user-select: none !important;
       -moz-user-select: none !important;
            user-select: none !important;
}

/*
 * Map/Satellite toggle typography (Figma 207-9985). Google Maps renders its native
 * controls into plain light-DOM elements (not a Blocks shadow DOM), so a scoped
 * selector reaches them directly. .refreshed-map-controls is only applied when the
 * eflowLiveDashboardRefresh layout is active, so the legacy map is untouched.
 */
.refreshed-map-controls .gm-style-mtc button {
    color: #565656;
    font-family: Roboto, sans-serif;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: center;
}

.refreshed-map-controls .gm-style-mtc button[aria-pressed="true"] {
    color: #000;
    font-weight: 500;
}

/* Figma 207-9987/207-9989 size these controls at 28px; Google renders them at 40px.
   The zoom widget has no stable class, so reach its container via the buttons' labels
   and scale it as one unit (scaling each button leaves the wrapper full size). */
.refreshed-map-controls .gm-fullscreen-control,
.refreshed-map-controls div:has(> button[aria-label="Zoom in"]),
.refreshed-map-controls div:has(> button[title="Zoom in"]) {
    transform: scale(0.7);
}

/* Nudge the zoom widget down a bit further from the corner (fullscreen control untouched). */
.refreshed-map-controls div:has(> button[aria-label="Zoom in"]),
.refreshed-map-controls div:has(> button[title="Zoom in"]) {
    margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/GoogleMaps/ProjectDetailsMaps.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA,mDAAmD;AACnD;;IAEI,oCAA4B;OAA5B,iCAA4B;YAA5B,4BAA4B;AAChC;;AAEA;;;;;EAKE;AACF;IACI,cAAc;IACd,+BAA+B;IAC/B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;;iFAEiF;AACjF;;;IAGI,qBAAqB;AACzB;;AAEA,6FAA6F;AAC7F;;IAEI,gBAAgB;AACpB","sourcesContent":[".gm-style-iw-chr {\n    display: none;\n}\n\n/* Prevent text selection on Google Maps elements */\n.gm-style,\n.gm-style * {\n    user-select: none !important;\n}\n\n/*\n * Map/Satellite toggle typography (Figma 207-9985). Google Maps renders its native\n * controls into plain light-DOM elements (not a Blocks shadow DOM), so a scoped\n * selector reaches them directly. .refreshed-map-controls is only applied when the\n * eflowLiveDashboardRefresh layout is active, so the legacy map is untouched.\n */\n.refreshed-map-controls .gm-style-mtc button {\n    color: #565656;\n    font-family: Roboto, sans-serif;\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    text-align: center;\n}\n\n.refreshed-map-controls .gm-style-mtc button[aria-pressed=\"true\"] {\n    color: #000;\n    font-weight: 500;\n}\n\n/* Figma 207-9987/207-9989 size these controls at 28px; Google renders them at 40px.\n   The zoom widget has no stable class, so reach its container via the buttons' labels\n   and scale it as one unit (scaling each button leaves the wrapper full size). */\n.refreshed-map-controls .gm-fullscreen-control,\n.refreshed-map-controls div:has(> button[aria-label=\"Zoom in\"]),\n.refreshed-map-controls div:has(> button[title=\"Zoom in\"]) {\n    transform: scale(0.7);\n}\n\n/* Nudge the zoom widget down a bit further from the corner (fullscreen control untouched). */\n.refreshed-map-controls div:has(> button[aria-label=\"Zoom in\"]),\n.refreshed-map-controls div:has(> button[title=\"Zoom in\"]) {\n    margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
